
import { useState } from 'react';

interface EventMapProps {
  address: string;
  locationName: string;
}

export default function EventMap({ address, locationName }: EventMapProps) {
  const [mapError, setMapError] = useState(false);
  const query = encodeURIComponent(`${locationName}, ${address}`);
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${query}`;
  const embedUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU3Kuo&q=${query}`;

  return (
    <div className="mb-10">
      <h2 className="text-2xl font-bold text-gray-900 mb-5 flex items-center gap-2">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-map-pin-2-line text-teal-600 text-2xl"></i>
        </div>
        <span>Venue Location</span>
      </h2>

      <div className="rounded-2xl overflow-hidden shadow-md border border-gray-100">
        {/* Map Header */}
        <div className="bg-white px-5 py-4 flex items-center justify-between border-b border-gray-100">
          <div>
            <p className="font-semibold text-gray-900 text-sm">{locationName}</p>
            <p className="text-gray-500 text-xs mt-0.5">{address}</p>
          </div>
          <a
            href={directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-teal-600 text-white text-sm font-semibold px-4 py-2 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-navigation-line text-sm"></i>
            </div>
            Get Directions
          </a>
        </div>

        {/* Google Maps Iframe */}
        {!mapError ? (
          <iframe
            title={`Map of ${locationName}`}
            width="100%"
            height="360"
            style={{ border: 0, display: 'block' }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={embedUrl}
            onError={() => setMapError(true)}
          />
        ) : (
          /* Fallback static map via OpenStreetMap */
          <div className="relative h-[360px] bg-gray-100 flex flex-col items-center justify-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full">
              <i className="ri-map-2-line text-teal-600 text-3xl"></i>
            </div>
            <div className="text-center">
              <p className="font-semibold text-gray-800">{locationName}</p>
              <p className="text-gray-500 text-sm">{address}</p>
            </div>
            <a
              href={directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-teal-600 text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-navigation-line"></i>
              Open in Google Maps
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
